export interface VideoItem {
  id: string;
  title: string;
  subtitle: string;
  category: 'movie' | 'drama' | 'variety' | 'short';
  type: string;
  year: number;
  region: string;
  duration: string;
  rating: number;
  plays: number;
  cover: string;
  description: string;
  updatedAt: string;
  tags: string[];
  featured: boolean;
}

export const videos: VideoItem[] = [
  {
    id: 'v001',
    title: '星际远征',
    subtitle: '人类踏向银河深处的最后一次启程',
    category: 'movie',
    type: '电影',
    year: 2025,
    region: '中国大陆',
    duration: '142分钟',
    rating: 9.1,
    plays: 12860000,
    cover: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20space%20opera%20movie%20poster%20hero%2C%20lone%20astronaut%20silhouette%20before%20a%20giant%20ringed%20planet%2C%20deep%20blue%20nebula%20backdrop%2C%20cinematic%20volumetric%20light%2C%20ultra%20detailed%20digital%20painting&width=960&height=540&seq=cover-v001&orientation=landscape',
    description: '一支由六名宇航员组成的远征队，承载着人类最后的希望驶向银河深处。当飞船穿越虫洞后，他们发现等待自己的不仅是未知的文明，还有关于人类起源的惊人真相。',
    updatedAt: '2025-09-28',
    tags: ['科幻', '冒险', '太空'],
    featured: true,
  },
  {
    id: 'v002',
    title: '长夜将明',
    subtitle: '一桩悬案背后，藏着整座城市的秘密',
    category: 'movie',
    type: '电影',
    year: 2025,
    region: '中国大陆',
    duration: '118分钟',
    rating: 8.7,
    plays: 9430000,
    cover: 'https://readdy.ai/api/search-image?query=Moody%20crime%20thriller%20movie%20key%20art%2C%20rain%20slicked%20city%20street%20at%20night%20with%20single%20streetlamp%20glow%2C%20lone%20detective%20coat%20silhouette%2C%20cold%20cyan%20and%20amber%20contrast%2C%20cinematic%20noir%20lighting&width=960&height=540&seq=cover-v002&orientation=landscape',
    description: '资深刑警在一桩尘封七年的悬案里发现了新的线索。随着调查深入，案件的真相逐渐牵出整座城市不愿被人提起的往事。',
    updatedAt: '2025-09-20',
    tags: ['悬疑', '犯罪', '剧情'],
    featured: true,
  },
  {
    id: 'v003',
    title: '山海拾遗',
    subtitle: '翻开古籍，山海之间的神兽悄然苏醒',
    category: 'movie',
    type: '电影',
    year: 2024,
    region: '中国大陆',
    duration: '131分钟',
    rating: 8.4,
    plays: 8120000,
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20fantasy%20film%20poster%2C%20misty%20ink%20wash%20mountains%20with%20a%20glowing%20mythical%20beast%20emerging%2C%20ancient%20scroll%20textures%2C%20teal%20and%20gold%20palette%2C%20ornate%20oriental%20illustration&width=960&height=540&seq=cover-v003&orientation=landscape',
    description: '年轻的古籍修复师意外唤醒了沉睡在山海经中的神兽。为了不让古老的力量失控，他必须踏上一段跨越现实与传说边界的旅程。',
    updatedAt: '2025-08-30',
    tags: ['奇幻', '冒险', '国风'],
    featured: true,
  },
  {
    id: 'v004',
    title: '城市之光',
    subtitle: '每个深夜归家的人，都值得一盏灯',
    category: 'movie',
    type: '电影',
    year: 2025,
    region: '中国大陆',
    duration: '106分钟',
    rating: 8.9,
    plays: 7240000,
    cover: 'https://readdy.ai/api/search-image?query=Warm%20urban%20drama%20film%20poster%2C%20city%20skyline%20at%20dusk%20with%20thousands%20of%20lit%20windows%2C%20soft%20amber%20streetlights%20and%20blue%20hour%20tones%2C%20cinematic%20wide%20shot%20with%20gentle%20bokeh&width=960&height=540&seq=cover-v004&orientation=landscape',
    description: '一位夜班出租车司机和一位便利店店员，在城市的深夜相遇。两个平凡人对生活的坚持，照亮了彼此最暗淡的时刻。',
    updatedAt: '2025-09-15',
    tags: ['剧情', '治愈', '温情'],
    featured: false,
  },
  {
    id: 'v005',
    title: '无声告白',
    subtitle: '有些话，隔着时光才听得见',
    category: 'movie',
    type: '电影',
    year: 2024,
    region: '中国香港',
    duration: '98分钟',
    rating: 8.2,
    plays: 5210000,
    cover: 'https://readdy.ai/api/search-image?query=Romantic%20drama%20movie%20poster%2C%20two%20figures%20standing%20apart%20on%20a%20seaside%20pier%20at%20golden%20hour%2C%20soft%20pastel%20sky%2C%20delicate%20emotional%20mood%2C%20dreamy%20film%20grain%20aesthetic&width=960&height=540&seq=cover-v005&orientation=landscape',
    description: '一封迟到了十年的信，让两个人重新回到那个夏天。过往的误会与未说出口的心意，在时光里慢慢被读懂。',
    updatedAt: '2025-07-18',
    tags: ['爱情', '文艺', '时光'],
    featured: false,
  },
  {
    id: 'v006',
    title: '追风者',
    subtitle: '极限赛道上的速度与信念',
    category: 'movie',
    type: '电影',
    year: 2025,
    region: '中国大陆',
    duration: '124分钟',
    rating: 8.0,
    plays: 6890000,
    cover: 'https://readdy.ai/api/search-image?query=High%20octane%20action%20racing%20film%20poster%2C%20supercar%20drifting%20through%20a%20night%20city%20tunnel%20with%20motion%20blur%20light%20trails%2C%20dramatic%20orange%20and%20blue%20contrast%2C%20dynamic%20cinematic%20energy&width=960&height=540&seq=cover-v006&orientation=landscape',
    description: '退役赛车手为了替弟弟还清债务，重返地下赛道。在一场场极限对决中，他重新找回了对速度最纯粹的热爱。',
    updatedAt: '2025-09-06',
    tags: ['动作', '赛车', '热血'],
    featured: false,
  },
  {
    id: 'v007',
    title: '雨林迷踪',
    subtitle: '深入无人区，寻找失落的科考队',
    category: 'movie',
    type: '电影',
    year: 2024,
    region: '中国大陆',
    duration: '115分钟',
    rating: 7.8,
    plays: 4180000,
    cover: 'https://readdy.ai/api/search-image?query=Adventure%20jungle%20expedition%20film%20poster%2C%20dense%20emerald%20rainforest%20canopy%20with%20shafts%20of%20sunlight%2C%20small%20explorer%20figures%20crossing%20a%20rope%20bridge%20over%20mist%2C%20lush%20green%20tones&width=960&height=540&seq=cover-v007&orientation=landscape',
    description: '一支搜救队深入亚马逊雨林，寻找失联的科考小组。随着足迹的延伸，他们发现这片雨林藏着一个不该被发现的秘密。',
    updatedAt: '2025-06-22',
    tags: ['冒险', '悬疑', '自然'],
    featured: false,
  },
  {
    id: 'v008',
    title: '山河故人录',
    subtitle: '乱世之中，一诺千金的守城人',
    category: 'movie',
    type: '电影',
    year: 2025,
    region: '中国大陆',
    duration: '136分钟',
    rating: 8.6,
    plays: 6350000,
    cover: 'https://readdy.ai/api/search-image?query=Historical%20epic%20Chinese%20film%20poster%2C%20ancient%20city%20walls%20under%20a%20stormy%20sky%2C%20armored%20general%20with%20banner%20silhouette%2C%20muted%20earth%20and%20crimson%20tones%2C%20grand%20painterly%20composition&width=960&height=540&seq=cover-v008&orientation=landscape',
    description: '王朝更迭之际，一座边城成了最后的防线。守城将领用一生的承诺守护百姓，也守住了山河故人最后的尊严。',
    updatedAt: '2025-08-12',
    tags: ['历史', '战争', '家国'],
    featured: false,
  },
  {
    id: 'v009',
    title: '深海回响',
    subtitle: '海平面之下，传来不该存在的信号',
    category: 'movie',
    type: '电影',
    year: 2025,
    region: '中国大陆',
    duration: '112分钟',
    rating: 8.3,
    plays: 5740000,
    cover: 'https://readdy.ai/api/search-image?query=Underwater%20sci-fi%20thriller%20film%20poster%2C%20deep%20ocean%20abyss%20with%20a%20lone%20submarine%20and%20eerie%20bioluminescent%20glow%2C%20dark%20teal%20and%20cyan%20depth%20gradient%2C%20mysterious%20atmospheric%20mood&width=960&height=540&seq=cover-v009&orientation=landscape',
    description: '深海研究站接收到一段来自海沟深处的神秘信号。当潜航器下潜到前所未有的深度，船员们意识到打扰的东西远比他们想象中古老。',
    updatedAt: '2025-09-24',
    tags: ['科幻', '惊悚', '深海'],
    featured: false,
  },
  {
    id: 'v010',
    title: '归途列车',
    subtitle: '跨越三千公里的回家路',
    category: 'movie',
    type: '电影',
    year: 2024,
    region: '中国大陆',
    duration: '102分钟',
    rating: 8.5,
    plays: 4620000,
    cover: 'https://readdy.ai/api/search-image?query=Heartfelt%20road%20drama%20film%20poster%2C%20old%20green%20train%20crossing%20a%20snowy%20countryside%20at%20dawn%2C%20warm%20windows%20glow%2C%20nostalgic%20soft%20palette%2C%20quiet%20cinematic%20wide%20composition&width=960&height=540&seq=cover-v010&orientation=landscape',
    description: '一张站票、一个旧行李包和一段三千公里的旅程。在外打拼多年的父亲，坐上归途列车，只为赶上女儿的一场演出。',
    updatedAt: '2025-05-30',
    tags: ['剧情', '家庭', '治愈'],
    featured: false,
  },
  {
    id: 'v011',
    title: '幻影追凶',
    subtitle: '每一个目击者，都在说谎',
    category: 'movie',
    type: '电影',
    year: 2025,
    region: '中国大陆',
    duration: '109分钟',
    rating: 7.9,
    plays: 3960000,
    cover: 'https://readdy.ai/api/search-image?query=Dark%20crime%20mystery%20film%20poster%2C%20blurred%20figure%20reflected%20in%20a%20rainy%20window%20with%20police%20lights%2C%20desaturated%20blue%20and%20grey%20tones%2C%20tense%20atmospheric%20noir%20composition&width=960&height=540&seq=cover-v011&orientation=landscape',
    description: '一起银行劫案留下了五种完全不同的证词。侦探必须在谎言的迷宫里，找到那个根本不存在的目击者。',
    updatedAt: '2025-08-04',
    tags: ['犯罪', '悬疑', '推理'],
    featured: false,
  },
  {
    id: 'v012',
    title: '麦田里的夏天',
    subtitle: '那年夏天，风穿过金色的麦浪',
    category: 'movie',
    type: '电影',
    year: 2024,
    region: '中国大陆',
    duration: '95分钟',
    rating: 8.1,
    plays: 3140000,
    cover: 'https://readdy.ai/api/search-image?query=Coming%20of%20age%20art%20film%20poster%2C%20golden%20wheat%20field%20under%20a%20bright%20summer%20sky%20with%20two%20kids%20running%2C%20warm%20sunlit%20nostalgia%2C%20soft%20film%20grain%20aesthetic&width=960&height=540&seq=cover-v012&orientation=landscape',
    description: '高考结束的那个夏天，四个小镇少年在麦田边许下承诺。多年以后回望，他们才明白那段时光究竟意味着什么。',
    updatedAt: '2025-04-16',
    tags: ['青春', '文艺', '成长'],
    featured: false,
  },
  {
    id: 'v013',
    title: '长安烟雨',
    subtitle: '一城烟雨，半部盛唐秘史',
    category: 'drama',
    type: '电视剧',
    year: 2025,
    region: '中国大陆',
    duration: '全40集 · 每集45分钟',
    rating: 9.0,
    plays: 15670000,
    cover: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20drama%20poster%2C%20misty%20dawn%20over%20ornate%20Tang%20dynasty%20city%20rooftops%2C%20elegant%20robe%20figure%20under%20a%20red%20lantern%2C%20teal%20and%20gold%20oriental%20palette%2C%20refined%20painterly%20detail&width=960&height=540&seq=cover-v013&orientation=landscape',
    description: '盛唐长安，一位出身寒门的少女进入大理寺。她凭借过人智慧侦破一桩桩奇案，也逐渐卷入朝堂之上更深的风雨。',
    updatedAt: '2025-10-02',
    tags: ['古装', '悬疑', '权谋'],
    featured: true,
  },
  {
    id: 'v014',
    title: '都市夜归人',
    subtitle: '深夜十二点，故事才刚刚开始',
    category: 'drama',
    type: '电视剧',
    year: 2025,
    region: '中国大陆',
    duration: '全32集 · 每集42分钟',
    rating: 8.6,
    plays: 11230000,
    cover: 'https://readdy.ai/api/search-image?query=Modern%20urban%20drama%20poster%2C%20sleek%20city%20street%20at%20midnight%20with%20neon%20signs%20and%20rain%20reflections%2C%20young%20professionals%20walking%2C%20cool%20blue%20violet%20night%20palette%2C%20clean%20cinematic%20look&width=960&height=540&seq=cover-v014&orientation=landscape',
    description: '深夜便利店、加班写字楼、午夜电台。六个在城市里打拼的年轻人，在各自的深夜相遇，也各自找到了继续前行的理由。',
    updatedAt: '2025-09-27',
    tags: ['都市', '群像', '治愈'],
    featured: false,
  },
  {
    id: 'v015',
    title: '迷雾档案',
    subtitle: '每一份卷宗，都是一段被掩埋的真相',
    category: 'drama',
    type: '电视剧',
    year: 2024,
    region: '中国大陆',
    duration: '全28集 · 每集44分钟',
    rating: 8.8,
    plays: 9870000,
    cover: 'https://readdy.ai/api/search-image?query=Crime%20mystery%20series%20poster%2C%20dim%20archive%20room%20with%20stacks%20of%20old%20case%20files%20and%20a%20single%20desk%20lamp%2C%20cold%20grey%20and%20amber%20contrast%2C%20suspenseful%20shadow%20composition&width=960&height=540&seq=cover-v015&orientation=landscape',
    description: '一个专门重查旧案的特别小组，在一堆被遗忘的卷宗里抽丝剥茧。每一个被翻开的档案，都牵动着某个家庭多年的执念。',
    updatedAt: '2025-08-21',
    tags: ['悬疑', '刑侦', '推理'],
    featured: false,
  },
  {
    id: 'v016',
    title: '少年游侠传',
    subtitle: '江湖再远，也远不过少年的脚步',
    category: 'drama',
    type: '电视剧',
    year: 2025,
    region: '中国大陆',
    duration: '全36集 · 每集40分钟',
    rating: 8.4,
    plays: 8640000,
    cover: 'https://readdy.ai/api/search-image?query=Wuxia%20martial%20arts%20drama%20poster%2C%20young%20swordsman%20on%20a%20cliff%20above%20a%20sea%20of%20clouds%20at%20sunrise%2C%20bamboo%20forest%20silhouettes%2C%20jade%20green%20and%20mist%20palette%2C%20elegant%20ink%20style&width=960&height=540&seq=cover-v016&orientation=landscape',
    description: '山村少年为寻missing的师父踏入江湖。一路结识挚友，也一路看清人心的复杂，在刀光剑影中慢慢成长为真正的大侠。',
    updatedAt: '2025-09-11',
    tags: ['武侠', '古装', '热血'],
    featured: false,
  },
  {
    id: 'v017',
    title: '星火燎原',
    subtitle: '那个年代，他们用青春点燃理想',
    category: 'drama',
    type: '电视剧',
    year: 2024,
    region: '中国大陆',
    duration: '全40集 · 每集46分钟',
    rating: 8.9,
    plays: 7830000,
    cover: 'https://readdy.ai/api/search-image?query=Period%20drama%20poster%2C%20vintage%201950s%20town%20street%20with%20warm%20dusty%20sunlight%2C%20group%20of%20young%20people%20walking%20together%2C%20sepia%20and%20amber%20tonal%20palette%2C%20nostalgic%20cinematic%20texture&width=960&height=540&seq=cover-v017&orientation=landscape',
    description: '上世纪五十年代，一群年轻人响应号召奔赴边疆建设。他们用双手在一片荒芜中建起家园，也用一生践行了年轻时的理想。',
    updatedAt: '2025-07-09',
    tags: ['年代', '励志', '群像'],
    featured: false,
  },
  {
    id: 'v018',
    title: '心动信号局',
    subtitle: '一场关于心动的甜蜜实验',
    category: 'drama',
    type: '电视剧',
    year: 2025,
    region: '中国大陆',
    duration: '全24集 · 每集38分钟',
    rating: 8.0,
    plays: 9150000,
    cover: 'https://readdy.ai/api/search-image?query=Romantic%20comedy%20drama%20poster%2C%20two%20young%20people%20under%20string%20lights%20on%20a%20rooftop%20at%20dusk%2C%20soft%20pink%20and%20peach%20pastel%20palette%2C%20sweet%20playful%20romantic%20mood&width=960&height=540&seq=cover-v018&orientation=landscape',
    description: '一群性格各异的年轻人参加了一档恋爱观察实验。在一次次心动与小误会里，他们学着坦诚，也学着如何好好喜欢一个人。',
    updatedAt: '2025-09-19',
    tags: ['甜宠', '都市', '青春'],
    featured: false,
  },
  {
    id: 'v019',
    title: '破晓行动',
    subtitle: '天亮之前，真相必须浮出水面',
    category: 'drama',
    type: '电视剧',
    year: 2025,
    region: '中国大陆',
    duration: '全30集 · 每集43分钟',
    rating: 8.7,
    plays: 6980000,
    cover: 'https://readdy.ai/api/search-image?query=Police%20procedural%20series%20poster%2C%20tactical%20team%20silhouettes%20during%20a%20dawn%20raid%20with%20sirens%20and%20blue%20light%2C%20gritty%20desaturated%20tones%2C%20tense%20action%20composition&width=960&height=540&seq=cover-v019&orientation=landscape',
    description: '一支特案组接到连环案件，线索却指向内部。时间所剩无几，他们必须在天亮之前，揭开这起案件背后真正的幕后之手。',
    updatedAt: '2025-10-05',
    tags: ['刑侦', '悬疑', '动作'],
    featured: false,
  },
  {
    id: 'v020',
    title: '白塔之下',
    subtitle: '当记忆可以被储存，你还相信真实吗',
    category: 'drama',
    type: '电视剧',
    year: 2025,
    region: '中国大陆',
    duration: '全26集 · 每集41分钟',
    rating: 8.5,
    plays: 6120000,
    cover: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20series%20poster%2C%20stark%20white%20research%20tower%20against%20a%20grey%20sky%2C%20lone%20figure%20looking%20up%2C%20minimal%20cold%20monochrome%20with%20a%20cyan%20accent%2C%20clean%20dystopian%20aesthetic&width=960&height=540&seq=cover-v020&orientation=landscape',
    description: '在记忆可被数字化储存的未来，一名记忆修复师发现了一段不该存在的回忆。追查下去，她开始怀疑自己的过去是否真实。',
    updatedAt: '2025-09-13',
    tags: ['科幻', '悬疑', '未来'],
    featured: false,
  },
  {
    id: 'v021',
    title: '我们的十年',
    subtitle: '一个屋檐下，十年烟火气',
    category: 'drama',
    type: '电视剧',
    year: 2024,
    region: '中国大陆',
    duration: '全34集 · 每集45分钟',
    rating: 8.3,
    plays: 5410000,
    cover: 'https://readdy.ai/api/search-image?query=Family%20life%20drama%20poster%2C%20cozy%20Chinese%20family%20gathered%20around%20a%20dinner%20table%20in%20warm%20lamplight%2C%20multiple%20generations%2C%20warm%20amber%20and%20beige%20tones%2C%20heartwarming%20composition&width=960&height=540&seq=cover-v021&orientation=landscape',
    description: '一套老房子，三代人，十年的春夏秋冬。柴米油盐里的磕磕绊绊，最终都化成了彼此最离不开的牵挂。',
    updatedAt: '2025-06-14',
    tags: ['家庭', '生活', '温情'],
    featured: false,
  },
  {
    id: 'v022',
    title: '山海纪事',
    subtitle: '神与人的约定，延续千年',
    category: 'drama',
    type: '电视剧',
    year: 2025,
    region: '中国大陆',
    duration: '全38集 · 每集44分钟',
    rating: 8.6,
    plays: 7590000,
    cover: 'https://readdy.ai/api/search-image?query=Fantasy%20mythology%20series%20poster%2C%20ancient%20shrine%20on%20a%20floating%20mountain%20above%20clouds%2C%20glowing%20celestial%20beast%20coiling%20around%20a%20pagoda%2C%20teal%20gold%20and%20jade%20palette%2C%20ornate%20oriental%20art&width=960&height=540&seq=cover-v022&orientation=landscape',
    description: '千年前，人与神立下约定，守护这方山海的平衡。千年后，一个普通少年无意间成为约定的继承者，从此卷入神与妖的纷争。',
    updatedAt: '2025-09-30',
    tags: ['奇幻', '古装', '国风'],
    featured: false,
  },
  {
    id: 'v023',
    title: '奇妙旅行团',
    subtitle: '八个人，一辆车，走遍世界的角落',
    category: 'variety',
    type: '综艺',
    year: 2025,
    region: '中国大陆',
    duration: '更新至第18期 · 每期90分钟',
    rating: 8.8,
    plays: 13450000,
    cover: 'https://readdy.ai/api/search-image?query=Fun%20travel%20variety%20show%20poster%2C%20bright%20colorful%20scenery%20with%20a%20group%20of%20friends%20laughing%20in%20a%20convertible%20van%20on%20a%20coastal%20road%2C%20sunny%20vivid%20palette%2C%20energetic%20joyful%20mood&width=960&height=540&seq=cover-v023&orientation=landscape',
    description: '八位性格迥异的嘉宾组成旅行团，用最朴素的预算走遍世界的角落。一路上状况百出，也意外收获了真挚的友情。',
    updatedAt: '2025-10-08',
    tags: ['旅行', '真人秀', '搞笑'],
    featured: true,
  },
  {
    id: 'v024',
    title: '舞台高光时刻',
    subtitle: '每一次登台，都是孤注一掷',
    category: 'variety',
    type: '综艺',
    year: 2025,
    region: '中国大陆',
    duration: '更新至第12期 · 每期120分钟',
    rating: 9.0,
    plays: 11870000,
    cover: 'https://readdy.ai/api/search-image?query=Music%20competition%20stage%20poster%2C%20dramatic%20concert%20stage%20with%20spotlights%20and%20laser%20beams%2C%20performer%20silhouette%20center%20stage%2C%20vibrant%20magenta%20and%20gold%20lighting%2C%20high%20energy%20show%20visual&width=960&height=540&seq=cover-v024&orientation=landscape',
    description: '来自各地的实力唱将同台竞技，从选曲到编舞都亲力亲为。谁能站上最后的舞台中央，由观众一起见证。',
    updatedAt: '2025-10-07',
    tags: ['音乐', '竞演', '舞台'],
    featured: false,
  },
  {
    id: 'v025',
    title: '厨房大作战',
    subtitle: '一锅一铲，做出人间烟火',
    category: 'variety',
    type: '综艺',
    year: 2024,
    region: '中国大陆',
    duration: '全20期 · 每期75分钟',
    rating: 8.4,
    plays: 8640000,
    cover: 'https://readdy.ai/api/search-image?query=Cooking%20competition%20show%20poster%2C%20bustling%20professional%20kitchen%20with%20chefs%20in%20action%20and%20steaming%20pans%2C%20warm%20golden%20lighting%2C%20appetizing%20vivid%20food%20colors%2C%20lively%20composition&width=960&height=540&seq=cover-v025&orientation=landscape',
    description: '素人厨师与专业大厨同台比试，限时挑战、盲盒食材轮番上阵。每一道菜背后，都藏着一个关于家的故事。',
    updatedAt: '2025-07-25',
    tags: ['美食', '竞技', '生活'],
    featured: false,
  },
  {
    id: 'v026',
    title: '推理之夜',
    subtitle: '真相只有一个，凶手就在我们中间',
    category: 'variety',
    type: '综艺',
    year: 2025,
    region: '中国大陆',
    duration: '更新至第16期 · 每期100分钟',
    rating: 8.7,
    plays: 7920000,
    cover: 'https://readdy.ai/api/search-image?query=Mystery%20detective%20variety%20show%20poster%2C%20elegant%20dim%20mansion%20parlor%20with%20candlelight%20and%20a%20round%20table%20of%20players%2C%20moody%20amber%20and%20deep%20green%20tones%2C%20suspenseful%20theatrical%20mood&width=960&height=540&seq=cover-v026&orientation=landscape',
    description: '每期一个全新案件，嘉宾们化身角色沉浸推理。在层层反转的剧本里，只有找出最关键的那条线索，才能锁定真凶。',
    updatedAt: '2025-10-04',
    tags: ['推理', '悬疑', '真人秀'],
    featured: false,
  },
  {
    id: 'v027',
    title: '快乐运动会',
    subtitle: '不服就上场，笑到最后的才算赢',
    category: 'variety',
    type: '综艺',
    year: 2024,
    region: '中国大陆',
    duration: '全18期 · 每期85分钟',
    rating: 8.1,
    plays: 6320000,
    cover: 'https://readdy.ai/api/search-image?query=Energetic%20sports%20variety%20show%20poster%2C%20sunny%20outdoor%20stadium%20with%20hosts%20competing%20in%20silly%20games%2C%20bright%20saturated%20primary%20colors%2C%20fun%20playful%20dynamic%20composition&width=960&height=540&seq=cover-v027&orientation=landscape',
    description: '明星与运动员组队，在趣味与竞技并存的赛场上展开较量。输赢之外，更让人难忘的是那些全场爆笑的瞬间。',
    updatedAt: '2025-06-30',
    tags: ['竞技', '搞笑', '真人秀'],
    featured: false,
  },
  {
    id: 'v028',
    title: '音乐星球',
    subtitle: '让每个声音，都被世界听见',
    category: 'variety',
    type: '综艺',
    year: 2025,
    region: '中国大陆',
    duration: '更新至第14期 · 每期95分钟',
    rating: 8.5,
    plays: 5830000,
    cover: 'https://readdy.ai/api/search-image?query=Music%20variety%20show%20poster%2C%20dreamy%20studio%20stage%20with%20glowing%20instruments%20and%20sound%20waves%2C%20soft%20aurora%20gradient%20of%20teal%20and%20amber%2C%20artistic%20atmospheric%20visual&width=960&height=540&seq=cover-v028&orientation=landscape',
    description: '来自民间的音乐人带着原创作品登上舞台。没有华丽包装，只有最真诚的声音，去打动每一位认真聆听的人。',
    updatedAt: '2025-09-16',
    tags: ['音乐', '原创', '梦想'],
    featured: false,
  },
  {
    id: 'v029',
    title: '露营慢生活',
    subtitle: '把生活的节奏，调慢一点',
    category: 'variety',
    type: '综艺',
    year: 2024,
    region: '中国大陆',
    duration: '全16期 · 每期70分钟',
    rating: 8.3,
    plays: 4710000,
    cover: 'https://readdy.ai/api/search-image?query=Cozy%20camping%20lifestyle%20show%20poster%2C%20warm%20campfire%20and%20tent%20beside%20a%20calm%20lake%20at%20twilight%2C%20soft%20string%20lights%2C%20pine%20forest%20backdrop%2C%20serene%20warm%20amber%20palette&width=960&height=540&seq=cover-v029&orientation=landscape',
    description: '几位好友远离城市，在山野湖畔搭起帐篷、生起篝火。没有剧本，只有聊天、做饭和星空下的慢时光。',
    updatedAt: '2025-05-18',
    tags: ['生活', '治愈', '户外'],
    featured: false,
  },
  {
    id: 'v030',
    title: '脱口秀大会场',
    subtitle: '生活很苦，但笑点管够',
    category: 'variety',
    type: '综艺',
    year: 2025,
    region: '中国大陆',
    duration: '更新至第20期 · 每期80分钟',
    rating: 8.6,
    plays: 9260000,
    cover: 'https://readdy.ai/api/search-image?query=Stand-up%20comedy%20show%20poster%2C%20warmly%20lit%20small%20theatre%20stage%20with%20a%20single%20microphone%20stand%20and%20red%20curtain%2C%20intimate%20amber%20club%20lighting%2C%20inviting%20playful%20mood&width=960&height=540&seq=cover-v030&orientation=landscape',
    description: '一群把生活过成段子的人，吐槽工作、恋爱和日常的荒诞。台上三分钟，笑点密集到让人喘不过气。',
    updatedAt: '2025-10-09',
    tags: ['喜剧', '语言', '生活'],
    featured: false,
  },
  {
    id: 'v031',
    title: '一分钟美食',
    subtitle: '一分钟学会一道神级家常菜',
    category: 'short',
    type: '短视频',
    year: 2025,
    region: '中国大陆',
    duration: '1分钟',
    rating: 8.9,
    plays: 21400000,
    cover: 'https://readdy.ai/api/search-image?query=Vertical%20food%20short%20video%20cover%2C%20close%20up%20of%20sizzling%20wok%20with%20colorful%20fresh%20ingredients%2C%20steam%20and%20golden%20lighting%2C%20vivid%20appetizing%20colors%2C%20clean%20food%20photography&width=960&height=540&seq=cover-v031&orientation=landscape',
    description: '用一分钟，教你把常见的食材变成惊艳的家常菜。步骤清晰、上手简单，厨房新手也能轻松复刻。',
    updatedAt: '2025-10-11',
    tags: ['美食', '教程', '生活'],
    featured: true,
  },
  {
    id: 'v032',
    title: '城市瞬间',
    subtitle: '记录街头每一个动人的小瞬间',
    category: 'short',
    type: '短视频',
    year: 2025,
    region: '中国大陆',
    duration: '90秒',
    rating: 8.4,
    plays: 15600000,
    cover: 'https://readdy.ai/api/search-image?query=Street%20photography%20short%20video%20cover%2C%20candid%20moment%20of%20people%20crossing%20a%20sunlit%20city%20crosswalk%2C%20warm%20golden%20hour%20light%2C%20gentle%20film%20grain%2C%20documentary%20everyday%20life%20mood&width=960&height=540&seq=cover-v032&orientation=landscape',
    description: '用镜头记录城市街头的日常：晨跑的年轻人、卖花的老人、等公交的学生。平凡之处，处处是温柔。',
    updatedAt: '2025-10-10',
    tags: ['生活', '记录', '治愈'],
    featured: false,
  },
  {
    id: 'v033',
    title: '冷知识实验室',
    subtitle: '那些你不知道的奇妙真相',
    category: 'short',
    type: '短视频',
    year: 2025,
    region: '中国大陆',
    duration: '2分钟',
    rating: 8.7,
    plays: 18300000,
    cover: 'https://readdy.ai/api/search-image?query=Fun%20science%20short%20video%20cover%2C%20colorful%20laboratory%20glassware%20with%20glowing%20liquids%20and%20floating%20particles%2C%20bright%20playful%20teal%20and%20orange%20accents%2C%20clean%20illustrative%20style&width=960&height=540&seq=cover-v033&orientation=landscape',
    description: '每天两分钟，用一个有趣的小实验，讲清一个生活中常见的冷知识。看完你会忍不住说一句：原来如此。',
    updatedAt: '2025-10-09',
    tags: ['科普', '知识', '趣味'],
    featured: false,
  },
  {
    id: 'v034',
    title: '街舞30秒',
    subtitle: '三十秒，燃爆整条街',
    category: 'short',
    type: '短视频',
    year: 2025,
    region: '中国大陆',
    duration: '30秒',
    rating: 8.5,
    plays: 12900000,
    cover: 'https://readdy.ai/api/search-image?query=Street%20dance%20short%20video%20cover%2C%20dancer%20mid%20freeze%20pose%20in%20a%20graffiti%20urban%20alley%2C%20dramatic%20purple%20and%20orange%20rim%20lighting%2C%20energetic%20high%20contrast%20motion%20visual&width=960&height=540&seq=cover-v034&orientation=landscape',
    description: '三十秒的高能街舞片段，从 Breaking 到 Popping 一网打尽。每个动作干净利落，看得人热血沸腾。',
    updatedAt: '2025-10-06',
    tags: ['舞蹈', '街舞', '潮流'],
    featured: false,
  },
  {
    id: 'v035',
    title: '萌宠日记',
    subtitle: '养宠人的快乐，你不懂',
    category: 'short',
    type: '短视频',
    year: 2025,
    region: '中国大陆',
    duration: '1分钟',
    rating: 9.2,
    plays: 24700000,
    cover: 'https://readdy.ai/api/search-image?query=Adorable%20pet%20short%20video%20cover%2C%20fluffy%20orange%20cat%20and%20corgi%20puppy%20playing%20on%20a%20sunny%20soft%20blanket%2C%20warm%20cozy%20pastel%20tones%2C%20cute%20clean%20photography&width=960&height=540&seq=cover-v035&orientation=landscape',
    description: '一只橘猫和一只柯基的日常。拆家、抢食、互相嫌弃又互相依赖，每一帧都可爱到让人心都化了。',
    updatedAt: '2025-10-12',
    tags: ['萌宠', '治愈', '搞笑'],
    featured: false,
  },
  {
    id: 'v036',
    title: '手工奇想',
    subtitle: '把普通材料，变成惊喜',
    category: 'short',
    type: '短视频',
    year: 2025,
    region: '中国大陆',
    duration: '3分钟',
    rating: 8.3,
    plays: 9800000,
    cover: 'https://readdy.ai/api/search-image?query=DIY%20craft%20short%20video%20cover%2C%20hands%20assembling%20a%20miniature%20paper%20model%20on%20a%20wooden%20desk%20with%20scattered%20colorful%20materials%2C%20bright%20tidy%20warm%20lighting%2C%20creative%20cozy%20mood&width=960&height=540&seq=cover-v036&orientation=landscape',
    description: '用最普通的纸板、瓶盖和毛线，做出让人眼前一亮的小玩意。动手的过程，本身就是一种治愈。',
    updatedAt: '2025-10-07',
    tags: ['手工', '创意', '教程'],
    featured: false,
  },
];

